import { graphql } from 'react-relay/legacy';

export const designerDirectoryRootQuery = graphql`
    query designerDirectoryRootQuery(
        $resultsPerPage: Int
        $pageStartOffset: Int
        $page: Int
        $search: String
        $hasSearch: Boolean!
        $regionCodes: [String]
        $sortBy: DesignFirmsSortByTypes
        $showOnlyTpnFirms: Boolean
        $showTestFirms: Boolean
    ) {
        viewer {
            ...DesignerDirectoryWrapper_viewer
        }
    }
`;
